
import React from 'react';
import { User, Lock, Shield } from 'lucide-react';

interface CredentialsDisplayProps {
  username: string;
  password: string;
  pin: string;
}

const CredentialsDisplay = ({ username, password, pin }: CredentialsDisplayProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6 bg-gray-900 rounded-lg border-2 border-gray-600">
      <div className="bg-gray-800 px-4 py-4 rounded-lg border border-gray-600">
        <div className="flex items-center gap-2 mb-2">
          <User className="h-4 w-4 text-blue-400" />
          <span className="text-xs text-gray-400 uppercase font-semibold">Username</span>
        </div>
        <span className="font-mono text-white font-semibold text-lg">{username}</span>
      </div>
      
      <div className="bg-gray-800 px-4 py-4 rounded-lg border border-gray-600">
        <div className="flex items-center gap-2 mb-2">
          <Lock className="h-4 w-4 text-green-400" />
          <span className="text-xs text-gray-400 uppercase font-semibold">Password</span>
        </div>
        <span className="font-mono text-white font-semibold text-lg break-all">{password}</span>
      </div>
      
      <div className="bg-gray-800 px-4 py-4 rounded-lg border border-gray-600">
        <div className="flex items-center gap-2 mb-2">
          <Shield className="h-4 w-4 text-yellow-400" />
          <span className="text-xs text-gray-400 uppercase font-semibold">PIN</span>
        </div>
        <span className="font-mono text-white font-semibold text-lg">{pin}</span>
      </div>
    </div>
  );
};

export default CredentialsDisplay;
